export default "__VITE_ASSET__D9nMI5pZ__"